<template>
  <date-picker
    v-model="dateValue"
    :model-config="returnFormat"
    :locale="locale"
    :masks="{ input: showFormat }"
    :timezone="timezone"
    :mode="mode"
    v-bind="otherProps"
  >
    <template v-slot="{ inputValue, togglePopover }">
      <b-input-group>
        <b-form-input
          :placeholder="placeholder"
          class="bg-white"
          :class="dateValue ? 'round-0' : ''"
          :value="
            typeof inputValue === 'string' ? inputValue : check(inputValue)
          "
          :disabled="disabled"
          :readonly="readonly"
          @keydown="clear"
          @click="togglePopover()"
        />
        <b-input-group-append is-text v-if="dateValue">
          <feather-icon icon="XIcon" class="cursor-pointer" @click="reset" />
        </b-input-group-append>
      </b-input-group>
    </template>
  </date-picker>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import { BFormInput, BInputGroupAppend, BInputGroup } from 'bootstrap-vue'

export default {
  components: {
    DatePicker,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
  },
  props: {
    clean: {
      default: false,
      required: false,
    },
    new: {
      default: false,
      required: false,
    },
    value: {
      type: [String, Object],
      required: false,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    timezone: {
      type: String,
      required: false,
      default: '',
    },
    locale: {
      type: [String, Object],
      required: false,
      default: 'ru',
    },
    returnFormat: {
      type: Object,
      required: false,
      default: () => ({
        type: 'string',
        mask: 'YYYY-MM-DD',
      }),
    },
    showFormat: {
      type: String,
      required: false,
      default: 'DD.MM.YYYY',
    },
    mode: {
      type: String,
      required: false,
      default: 'date',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: true,
    },
    otherProps: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      dateValue: this.value,
    }
  },
  methods: {
    reset() {
      this.dateValue = null
    },

    clear(e) {
      if (e.code === 'Backspace') this.dateValue = null
    },
    check(e) {
      if (e.start) {
        return `${e.start || ''}-${e.end || ''}`
      }
      return ''
    },
  },
  watch: {
    clean(val) {
      if (val) {
        this.reset()
      }
      this.$emit('cancel', val)
    },
    new(val) {
      if (val) {
        this.reset()
      }
      this.$emit('cancel', val)
    },
    dateValue(val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style>
.round-0 {
  border-right: 0;
}
</style>
